import axios from 'axios';
import ss from './Session';

/**
 * @typedef {{
 *  userid: string,
 *  addressid: string,
 *  name: string | null,
 *  email: string | null,
 *  image: string | null,
 * }} profileType
 */

/**
 * 
 * @param {import('./Session').sessionType} session 
 * @param {{
 *  name?: string,
 *  email?: string,
 *  addressid?: string,
 *  image?: string
 * }} newProfileData
 * @returns {Promise<import('./Session').sessionType|Error>}
 */
export const updateProfile = async (newProfileData) => {
    let res = await axios.patch('https://api.webtoon.today/profile', newProfileData, {
        headers: {
            Authorization: `Bearer ${ss.getCurrentSession().jwt}`
        },
        withCredentials: true
    });

    if (res.data && res.data.code === 200){
        return res.data.data;
    }else{
        return new Error( res.data.message );
    }
};

/**
 * 
 * @param {import('./Session').sessionType} session 
 * @param {string} targetid
 * @returns {Promise<import('./Session').sessionType>}
 */
export const readProfile = async (targetid) => {
    let res = await axios.post(`https://api.webtoon.today/profile`, {targetid}, {
        headers: {
            Authorization: `Bearer ${ss.getCurrentSession().jwt}`
        },
        withCredentials: true
    });

    if (res.data && res.data.code === 200){
        if (!res.data.data.image){
            res.data.data.image = "https://static.webtoon.today/noimage.jpg";
        }
        return res.data.data;
    }else {
        return {
            userid: null,
            email: null,
            image: null,
            addressid: null,
        }
    }
}